import { styled } from "@mui/material";
import { Switch } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// Styled components
export const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  "width": 42,
  "height": 26,
  "padding": 0,
  "& .MuiSwitch-switchBase": {
    "padding": 0,
    "margin": 2,
    "transitionDuration": "300ms",
    "&.Mui-checked": {
      "transform": "translateX(16px)",
      "color": "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#73E2E0",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "#73E2E0",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#d0d0d0",
    opacity: 1,
    transition: "background-color 0.5s",
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

export const CustomDateCalendar = styled(DateCalendar)(() => ({
  "width": "100%",
  ".MuiPickersCalendarHeader-label": {
    color: "#42c0c7",
  },
  ".MuiPickersArrowSwitcher-root": {
    color: "#73E2E0",
  },
  ".MuiTypography-root": {
    color: "var(--text-color)",
    fontWeight: "600",
    fontSize: "17px",
  },
  ".MuiPickersYear-yearButton": {
    color: "#73E2E0",
  },
  ".MuiSvgIcon-root": {
    color: "#73E2E0",
  },
  ".MuiPickersDay-root": {
    "color": "#42C0C7",
    "fontWeight": "500",
    "fontSize": "16px",
    "&.Mui-disabled": {
      color: "var(--current-month) !important",
    },
    "&.Mui-selected": {
      "backgroundColor": "#73E2E0",
      "color": "var(--text-color-dark)",
      "&:hover": {
        backgroundColor: "#679796",
      },
    },
    "&.MuiPickersDay-today": {
      borderColor: "#73E2E0",
      color: "var(--text-color)",
    },
    "&.MuiPickersDay-dayWithInRange": {
      backgroundColor: "#73E2E0",
    },
    "&:hover": {
      backgroundColor: "#679796",
    },
    "&:focus": {
      backgroundColor: "#73E2E0",
    },
  },
}));

export const CustomTimePicker = styled(TimePicker)(() => ({
  "& .MuiInputBase-root": {
    width: "100%",
    height: "100%",
    paddingRight: "10px",
    display: "flex",
    alignItems: "center",
  },
  "& .MuiInputBase-input": {
    color: "var(--text-color)",
    fontSize: "18px",
    padding: "0 0 0 10px",
    textAlign: "center",
    cursor: "pointer",
    height: "100%",
  },
  "& .MuiInputAdornment-root": {
    "marginLeft": "5px",
    "& .MuiSvgIcon-root": {
      color: "#42C0C7",
      width: "24px",
      height: "24px",
    },
  },
}));
